export default "__VITE_ASSET__CsnU$XQh__"